import React, { useEffect, useState, useRef } from "react";
import { Form, Row, Col, Button, Container, FloatingLabel, Modal } from "react-bootstrap";
import axios from "axios";
import { formatDate, encryptId, decryptId } from "../utils/helpers";

import { Link, useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const API_URL = process.env.REACT_APP_API_URL;

function Literature_Avenue_Edit() {

    const navigate = useNavigate();

    const { master_id } = useParams();
    
    const decodedId = decodeURIComponent(master_id);
    const id_master = decryptId(decodedId);
    const alertShown = useRef(false);


    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const [comment, setComment] = useState("");
    const [literature, setLiterature] = useState("");

    const [autoSaveAfterDelete, setAutoSaveAfterDelete] = useState(false);

    const { user } = useAuth();
    ///////////////////////////
    const [showModal, setShowModal] = useState(false);
    const [password, setPassword] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [error, setError] = useState("");
    ////////////////////////////

    const [documents, setDocuments] = useState([
        { id: Date.now(), research_point: "", reference_link: "" }
    ]);

    const [literatures, setLiteratures] = useState([]);

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) return;

        axios.get(`${API_URL}/literature_types_list`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then((res) => setLiteratures(res.data.literatures || []))
            .catch((err) => console.error(err));
    }, []);



    // useEffect(() => {
    //     const token = localStorage.getItem("token");
    //     if (!token) return;

    //     axios
    //         .get(`${API_URL}/literature_avenue_data_id_wise/${master_id}`, {
    //             headers: { Authorization: `Bearer ${token}` }
    //         })
    //         .then(res => {
    //             const data = res.data.data_entry;

    //             setLiterature(data.literature_type || "");

    //             setComment(data.comment || "");
    //             // console.log(data);
    //             setDocuments(
    //                 data.documents?.length
    //                     ? data.documents.map(doc => ({
    //                         id: Date.now() + Math.random(),
    //                         research_point: doc.research_details,
    //                         reference_link: doc.reference_link,
    //                         trans_id: doc.trans_id,
    //                         deleted: false
    //                     }))
    //                     : [{ id: Date.now(), research_point: "", reference_link: "", trans_id: null, deleted: false }]
    //             );
    //         })
    //         .catch(err => console.error(err));
    // }, [master_id]);


    const fetchLiteratureData = async () => {
        const token = localStorage.getItem("token");
        if (!token) return;

        try {
            const res = await axios.get(
                `${API_URL}/literature_avenue_data_id_wise/${id_master}`,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            const data = res.data.data_entry;

            setLiterature(data.literature_type || "");
            setComment(data.comment || "");

            setDocuments(
                data.documents?.length
                    ? data.documents.map(doc => ({
                        id: Date.now() + Math.random(),
                        research_point: doc.research_details,
                        reference_link: doc.reference_link,
                        trans_id: doc.trans_id
                    }))
                    : []
            );

        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchLiteratureData();
    }, [id_master]);

    const addRow = () => {
        setDocuments([
            ...documents,
            { id: Date.now(), research_point: "", reference_link: "" }
        ]);
    };

    // const removeRow = (id) => {
    //     if (documents.length === 1) return;
    //     setDocuments(documents.filter((doc) => doc.id !== id));
    // };
    const removeRow = (id) => {
        if (documents.length === 0) return;

        const confirmDelete = window.confirm("Do you want to delete?");

        if (confirmDelete) {
            setDocuments(documents.filter((doc) => doc.id !== id));
        }
    };

    const handleChange = (id, field, value) => {
        setDocuments((docs) =>
            docs.map((doc) =>
                doc.id === id ? { ...doc, [field]: value } : doc
            )
        );
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    const handleSubmit = async (e = null, shouldRedirect = true) => {
        if (e) e.preventDefault();
        if (!literature) {
            alert("Please select literature name!");
            return;
        }

        if (documents.some(doc => !doc.research_point || !doc.reference_link)) {
            alert("Please fill all table fields!");
            return;
        }

        try {
            const payload = {
                comment,
                documents: documents
            };

            const response = await axios.post(
                `${API_URL}/update_literature_avenue/${id_master}`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`
                    }
                }
            );

            // alert(response.data.message);

            // ////////////////////////////////////

            // setSuccessMsg(response.data.message || "Updated successfully");
            // setErrorMsg("");

            // setTimeout(() => setSuccessMsg(""), 1000);

            // //////////////////////////////


            // navigate("/Literature_Avenue_List");



            // setTimeout(() => {
            //     navigate("/Literature_Avenue_List");
            // }, 1000);
            if (shouldRedirect) {
                setTimeout(() => {
                    navigate("/Literature_Avenue_List");
                }, 1000);
                setSuccessMsg(response.data.message || "Updated successfully");
                setErrorMsg("");
            } else {
                fetchLiteratureData();
                setSuccessMsg(response.data.message || "Updated successfully");
                setTimeout(() => setSuccessMsg(""), 1000);
                setErrorMsg("");
            }

            setLiterature("");
            setComment("");
            setDocuments([
                { id: Date.now(), research_point: "", reference_link: "" }
            ]);

        } catch (error) {

            console.error(error);
            ////////////////////////////////////
            setErrorMsg("Update failed");

            setTimeout(() => setErrorMsg(""), 1000);
            ////////////////////////////////////////////
            // alert("Error adding literature data!");
        }
    };

    const openPasswordModal = (literature_id) => {
        setSelectedId(literature_id);
        setPassword("");
        setError("");
        setShowModal(true);
    };


    const verifyPassword = async () => {
        try {
            const token = localStorage.getItem("token");

            const res = await axios.post(
                `${API_URL}/verify-password`,
                { password, uid: user?.uid },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            if (res.data.success) {
                setShowModal(false);

                removeRow(selectedId);
                setAutoSaveAfterDelete(true);
            } else {
                setError("Incorrect password");
            }
        } catch (err) {
            setError("Incorrect password");
        }
    };
    // useEffect(() => {
    //     if (autoSaveAfterDelete) {
    //         const fakeEvent = { preventDefault: () => { } };
    //         handleSubmit(fakeEvent);   // call API
    //         setAutoSaveAfterDelete(false);
    //     }
    // }, [documents]);
    useEffect(() => {
        if (autoSaveAfterDelete) {
            handleSubmit(null, false); // autosave without redirect
            setAutoSaveAfterDelete(false);
        }
    }, [documents]);

    return (
        <Container className="mt-4">
            {successMsg && (
                <div className="alert alert-success mt-2">
                    {successMsg}
                </div>
            )}

            {errorMsg && (
                <div className="alert alert-danger mt-2">
                    {errorMsg}
                </div>
            )}
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
                <h3>Update Literature Avenue</h3>



                <div className="d-flex gap-2">  <Link className="btn btn-sm btn-primary " to="/Literature_Avenue">Add New Data</Link>
                    <Link className="btn btn-primary btn-sm  mt-md-0" to="/Literature_Avenue_List">
                        List
                    </Link></div>

            </div>

            <Form autoComplete="off" onSubmit={handleSubmit}>
                <Row className="mt-3">
                    <Col xs={12} className="mb-3">
                        <Form.Label className="fw-semibold">Literature Theme</Form.Label>
                        <Form.Select
                            value={literature}
                            onChange={(e) => setLiterature(e.target.value)}
                            required disabled>
                            <option value="">-- Select Literature --</option>
                            {literatures.map((item) => (
                                <option key={item.literature_id} value={item.literature_id}>
                                    {item.literature_name}
                                </option>
                            ))}
                        </Form.Select>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12}>
                        <div className="table-responsive">
                            <table className="table table-bordered table-striped">
                                <thead style={{ backgroundColor: "#e6ffff" }}>
                                    <tr>
                                        <th>Sr.No</th>
                                        <th>Research Evidence Points</th>
                                        <th>Reference Link</th>
                                        <th className="text-center">
                                            <Button variant="success" size="sm" onClick={addRow}>
                                                + Add
                                            </Button>
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {documents.map((doc, index) => (
                                        <tr key={doc.id}>
                                            <td>{index + 1}</td>

                                            <td>
                                                <Form.Control
                                                    as="textarea"
                                                    placeholder="Enter research point" rows={3}
                                                    value={doc.research_point} required
                                                    onChange={(e) =>
                                                        handleChange(doc.id, "research_point", e.target.value)
                                                    }
                                                />
                                            </td>

                                            <td>
                                                <Form.Control
                                                    as="textarea" rows={3}
                                                    placeholder="Reference link"
                                                    value={doc.reference_link} required
                                                    onChange={(e) =>
                                                        handleChange(doc.id, "reference_link", e.target.value)
                                                    }
                                                />
                                            </td>

                                            <td className="text-center">
                                                <Button
                                                    variant="danger"
                                                    size="sm"
                                                    onClick={() => openPasswordModal(doc.id)}
                                                >
                                                    Delete
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Col>
                </Row>

                <Row className="mt-4">
                    <Col xs={12}>
                        <FloatingLabel label="Enter Comments">
                            <Form.Control
                                as="textarea"
                                style={{ height: "80px" }}
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                            />
                        </FloatingLabel>
                    </Col>
                </Row>

                <Row className="mt-4">
                    <Col className="text-center">
                        <Button type="submit" variant="primary">
                            Update
                        </Button>
                    </Col>
                </Row>
            </Form>
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                centered
                backdrop="static"
                keyboard={false}
                dialogClassName="soft-modal"
            >
                <Modal.Header closeButton style={{ borderBottom: "none" }}>
                    <Modal.Title style={{ fontWeight: 600, fontSize: "1.3rem" }}>
                        Confirm Password
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ padding: "2rem 2rem 1rem 2rem" }}>
                    <Form.Group>
                        <Form.Label style={{ fontWeight: 500, fontSize: "0.95rem", color: "#555" }}>
                            Enter your password
                        </Form.Label>
                        <Form.Control
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="" autoComplete="off"
                            style={{
                                borderRadius: "12px",
                                border: "1px solid #ddd",
                                padding: "10px 15px",
                                fontSize: "0.95rem",
                                boxShadow: "inset 0 2px 5px rgba(0,0,0,0.05)",
                            }}
                        />
                    </Form.Group>
                    {error && (
                        <p
                            className="text-danger mt-2"
                            style={{ fontSize: "0.9rem", fontWeight: 500 }}
                        >
                            {error}
                        </p>
                    )}
                </Modal.Body>

                <Modal.Footer style={{ borderTop: "none", padding: "1rem 2rem 2rem 2rem" }}>
                    <Button
                        variant="outline-secondary"
                        onClick={() => setShowModal(false)}
                        style={{
                            borderRadius: "10px",
                            padding: "8px 18px",
                            fontWeight: 500,
                            boxShadow: "0 3px 6px rgba(0,0,0,0.08)",
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={verifyPassword}
                        style={{
                            borderRadius: "10px",
                            padding: "8px 20px",
                            fontWeight: 600,
                            background: "linear-gradient(135deg,#6a9fff,#5a86ff)",
                            border: "none",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                        }}
                    >
                        Verify
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
}

export default Literature_Avenue_Edit;
